/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import styles from './DemoCard.module.scss';

import type { DemoCardProps } from './DemoCard.types';

export const DemoCard = ({
  title,
  status,
  live = true,
  footerLeft,
  footerRight,
  children,
  className,
  bodyClassName,
}: DemoCardProps) => (
  <div className={cn(styles.card, className)}>
    <div className={styles.head}>
      <span className={styles.title}>{title}</span>

      {status && <span className={cn(styles.status, live && styles.live)}>{status}</span>}
    </div>

    <div className={cn(styles.body, bodyClassName)}>{children}</div>

    {(footerLeft || footerRight) && (
      <div className={styles.strip}>
        <span>{footerLeft}</span>
        <span>{footerRight}</span>
      </div>
    )}
  </div>
);
